import * as React from "react";
const SvgCrop75 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 7H3v10h18V7zm-2 8H5V9h14v6z",
  fill: "currentColor"
}));
export default SvgCrop75;